var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.session_verified && !_vm.is_user_logged_in
        ? _c("CheckSession", {
            attrs: { is_pre2fa_route: _vm.is_pre2fa_route }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.check_session_executed
        ? [
            _vm.whitelabel.length === 0
              ? _c("loader")
              : [
                  _vm.is_guest
                    ? _c("GuestLayout", [_c("router-view")], 1)
                    : _c("MainLayout", [
                        _c("div", { staticClass: "container-fluid" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            [
                              _vm.show_system_messages === true
                                ? _c("SystemMessages")
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "container-ui col-xs-12 col-md-8 col-lg-9 col-xl-8"
                                },
                                [
                                  _vm.show_system_messages === true
                                    ? _c("SystemAlerts")
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.show_system_messages === true
                                    ? [_c("router-view")]
                                    : [_c("router-view")]
                                ],
                                2
                              )
                            ],
                            1
                          )
                        ])
                      ])
                ]
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c("modals-container"),
      _vm._v(" "),
      _c("v-dialog"),
      _vm._v(" "),
      _c("vue-notifications", {
        attrs: {
          position: "top right",
          duration: 5000,
          classes: "ccs-notification"
        }
      }),
      _vm._v(" "),
      _c("ccs-modal")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }